// extracted by mini-css-extract-plugin
export default {"colorPicker":"WorkflowStep_colorPicker__LXBK4","comboInput":"WorkflowStep_comboInput__nQEHD"};